module.exports = __webpack_public_path__ + "images/plane@2x---af59ec9728fef312b953157d71f1c501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plane@2x.png
// module id = 394
// module chunks = 0